/* eslint-disable max-len */
import { getMessage } from '../../translations';
import { getUserFromLocalStorage } from '../../component/utils/user';
const userLang = getUserFromLocalStorage();
const languageCode = userLang?.language?.toLowerCase().startsWith('en') ? 'en' : userLang?.language?.toLowerCase() || 'default-language';

export const getDeliveriesImporterSetting = ({ dropdownData, conditioningDropdownData }) => ({
  //multipleFileUpload: true,
  developerMode: false,
  identifier: 'deliveries',
  language: languageCode,
  disableTemplates: true,
  allowManualInput: false,
  numberFormat: "us",
  processingEngine: "node",
  inputTypes: ["csv", "tsv", "xls", "xlsx", "pdf"],
  i18nOverrides: {
    txt_back_page_dialog: getMessage("If you press the \"Go back\" button, you will lose the progress of the current step."),
    txt_close_page_modal: getMessage("If you press the \"Go back\" button, you will lose the entire progress of all steps."),
    txt_confirm_submit_data_with_error: getMessage("Are you sure you want to submit your data? Rows with an error wont be imported. If yes, please use the “Submit” button. Otherwise, press the “Back” button"),
    txt_confirm_submit_data_without_error: getMessage("Are you sure you want to submit your data? If yes, please use the “Submit” button. Otherwise, press the “Back” button"),
    txt_allow_error_confirm_submit_data_with_error: getMessage("Are you sure you want to submit your data? Rows with an error will be imported as well. If yes, please use the “Submit” button. Otherwise, press the “Back” button"),
    txt_import_data_error_exceed: getMessage("Your import resulted in {{error}} errors. If you want to correct these errors inside the application, press the “Continue” button. Otherwise, you could download the merged table as Excel (.xlsx) by pressing the “Export as Excel” button."),
  },
  columns: [
    {
      key: 'qualityName',
      label: getMessage('MATERIAL'),
      description: getMessage('The commodity or material name'),
      columnType: 'category',
      alternativeMatches: ['Material', 'Produit', 'produit', 'Commodity Name', 'Nom du produit', 'Qualité'],
      // dropdownOptions: dropdownData,
      dropdownOptions: Array.isArray(dropdownData) ? dropdownData : [],
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage('The material name cannot be blank'),
        },
      ],
      isMultiSelect: false,
    },
    {
      key: 'quantityQuantity',
      label: getMessage('Net Weight'),
      description: getMessage('Quantity of material in delivery'),
      example: '19,335',
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: ['Quantity', 'Amount', 'Net', 'Poids', 'poids', 'Poids net'],
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage('Quantity cannot be left blank'),
        },
      ],
    },
    {
      key: 'dateOfDelivery',
      label: getMessage('Date of delivery'),
      description: getMessage('Date of delivery'),
      example: '2023-07-22T15:52:45.175Z',
      columnType: 'date',
      alternativeMatches: ['Date', 'Delivery date'],
      outputFormat: 'MM/DD/YYYY',
    },
    {
      key: 'referenceNumber',
      label: getMessage('Reference number'),
      description: getMessage('Container reference number'),
      example: 'DM31345',
      columnType: 'string',
      alternativeMatches: [
        'ID',
        'Container reference number',
        'reference ID',
        'referenceId',
        'Container number',
        'Vehicule',
        'vehicule',
        'N° DE TRACTEUR',
      ],
    },
    {
      key: 'erpContainerId',
      label: getMessage('ERP Container id'),
      description: getMessage('ERP Container id'),
      example: 'BG921AY',
      columnType: 'string',
      hidden: true,
      alternativeMatches: [
        'ERP ID',
        'ERP reference number',
        'ERP container number',
        'ERP Container ID',
      ],
    },
    {
      key: 'deliveryComment',
      label: getMessage('Delivery comment'),
      columnType: 'string',
    },
    {
      key: 'quantityInTons',
      label: getMessage('Quantity in tons'),
      description: getMessage('Quantity converted to tons'),
      example: '37,895',
      columnType: 'float',
      numberFormat: 'us',
    },
    {
      key: 'harold_number',
      label: getMessage('Jules number'),
      description: getMessage('CT number for the truck or container'),
      example: 'CT2023-08-0001131',
      columnType: 'string',
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage('This number name cannot be blank'),
        },
      ],
      alternativeMatches: [
        'Container Ref',
        'ContainerReference',
        'Container ref.',
        'Libelle',
        'libelle',
        'Jules container',
        'camion no',
        'Numéro CT',
        'Numero CT',
      ],
    },
    {
      key: 'deliveryOtherNumber',
      label: getMessage('Other delivery number'),
      description: getMessage('Any other delivery reference number'),
      example: 'HC16547',
      columnType: 'string',
      alternativeMatches: ['delivery number', 'delivery no', 'Reference'],
    },
    {
      key: 'sterileQuantity',
      label: getMessage('Sterile Weight'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: [
        'Sterile Weight',
        'Sterile weight',
        'Poids stérile',
        'Poids dechets',
        'POIDS DECHETS',
      ],
    },
  ],
});